import React from 'react';
import background from '../../assets/cleanwater.jpg';
import ReusableInfoCard from '../../components/ReusableInfoCard/ReusableInfoCard';


class InfoCleanwater extends React.Component {
  render () { 
   return(
  
  <ReusableInfoCard             
    
        tag="LAND"
        description="Clean Water"
        paragraph="Water availability is becoming less predictable in many places, and increased incidences of flooding threaten to destroy water points and sanitation facilities and contaminate water sources (UN Water)."
        background={background}
     />
  
  );
 }
}   

export default InfoCleanwater;